export default __webpack_public_path__ + "audio/a46641155fbf37be3ae62cad6a6e1928-enemyCrush.wav";